import { siteInfo } from '@/mocks/site';
import { type Article } from '@/mocks/articles';

export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.fullName,
    alternateName: siteInfo.name,
    url: siteInfo.url,
    email: siteInfo.email,
    telephone: siteInfo.phone,
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'CN',
      addressLocality: '北京',
      streetAddress: siteInfo.address,
    },
    foundingDate: String(siteInfo.foundedYear),
    description: siteInfo.description,
    sameAs: [
      siteInfo.socialLinks.weibo,
    ],
  };
}

export function getWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.fullName,
    url: siteInfo.url,
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteInfo.url}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };
}

export function getWebPageSchema(title: string, description: string, url: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description,
    url,
    isPartOf: {
      '@type': 'WebSite',
      name: siteInfo.fullName,
      url: siteInfo.url,
    },
    about: {
      '@type': 'Thing',
      name: '网络安全教育',
      description: siteInfo.description,
    },
  };
}

export function getBreadcrumbSchema(items: { name: string; item?: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.item || siteInfo.url,
    })),
  };
}

export function getArticleSchema(article: Article) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    author: {
      '@type': 'Person',
      name: article.author,
    },
    datePublished: article.date,
    dateModified: article.date,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${siteInfo.url}/article/${article.slug}`,
    },
    publisher: {
      '@type': 'Organization',
      name: siteInfo.fullName,
      logo: {
        '@type': 'ImageObject',
        url: `${siteInfo.url}/logo.png`,
      },
    },
    keywords: article.tags.join(','),
    articleSection: article.category,
  };
}

export function getFAQSchema(faqItems: { question: string; answer: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };
}